import React from 'react';
import { Box, Typography } from '@mui/material';

const SouthKoreaRegistry = () => (
  <Box sx={{ py: 3, px: 2 }}>
    <Typography variant="h5" gutterBottom>
      South Korea Clinical Research Information Service (CRIS)
    </Typography>
    <Typography variant="body1" color="text.secondary">
      Prepare CRIS entries and monitor approval progress.
    </Typography>
  </Box>
);

export default SouthKoreaRegistry;



